import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";

import { AppRoutingModule } from "../app-routing.module";

import { AppCoreModule } from "../core/app-core.module";

// Templates
import { OneColumnComponent } from "./templates/one-column/one-column.component";

// Pages
import { ConfirmationComponent } from "./pages/confirmation/confirmation.component";
import { OverflowErrorComponent } from "./pages/overflow-error/overflow-error.component";
import { UploadComponent } from "./pages/upload/upload.component";
import { WelcomeComponent } from "./pages/welcome/welcome.component";

// Structures
import { FormConfirmationComponent } from "./structures/form-confirmation/form-confirmation.component";
import { FormPopupMessageBoxComponent } from "./structures/form-popup-message-box/form-popup-message-box.component";
import { FormUploadComponent } from "./structures/form-upload/form-upload.component";
import { FormWelcomeComponent } from "./structures/form-welcome/form-welcome.component";
import { OverflowErrorViewComponent } from "./structures/overflow-error-view/overflow-error-view.component";

// Groups
import { ContentMessageComponent } from "./groups/content-message/content-message.component";
import { FormFieldComponent } from "./groups/form-field/form-field.component";
import { FormFileInputDragComponent } from "./groups/form-file-input-drag/form-file-input-drag.component";
import { NavPillsComponent } from "./groups/nav-pills/nav-pills.component";
import { ProgressStepBarWithNumberComponent } from "./groups/progress-step-bar-with-number/progress-step-bar-with-number.component";

// Elements
import { BackgroundBlackComponent } from "./elements/background-black/background-black.component";
import { ButtonComponent } from "./elements/button/button.component";
import { CirclePointWithNumberComponent } from "./elements/circle-point-with-number/circle-point-with-number.component";
import { LoadingThreePointComponent } from "./elements/loading-three-point/loading-three-point.component";
import { ProgressBarComponent } from "./elements/progress-bar/progress-bar.component";
import { TextDescriptionComponent } from "./elements/text-description/text-description.component";
import { TextLinkComponent } from "./elements/text-link/text-link.component";
import { TextTitleComponent } from "./elements/text-title/text-title.component";

@NgModule({
  declarations: [
    BackgroundBlackComponent,
    ButtonComponent,
    CirclePointWithNumberComponent,
    ConfirmationComponent,
    ContentMessageComponent,
    FormConfirmationComponent,
    FormFieldComponent,
    FormFileInputDragComponent,
    FormPopupMessageBoxComponent,
    FormUploadComponent,
    FormWelcomeComponent,
    LoadingThreePointComponent,
    NavPillsComponent,
    OneColumnComponent,
    OverflowErrorComponent,
    OverflowErrorViewComponent,
    ProgressBarComponent,
    ProgressStepBarWithNumberComponent,
    TextDescriptionComponent,
    TextLinkComponent,
    TextTitleComponent,
    UploadComponent,
    WelcomeComponent,
  ],
  exports: [OneColumnComponent],
  imports: [
    AppCoreModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: "6LfWScYUAAAAAMyl3_sWSZRGtfBeKZOuJnCDJQWq",
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppDesignModule {}
